import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import WarningPopup from "./WarningPopup";
import { useWarningPopup } from "@/contexts/WarningPopupContext";

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

const Layout = ({ children, showFooter = true }: LayoutProps) => {
  const { open } = useWarningPopup();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-24 md:pt-28">{children}</main>
      {showFooter && <Footer />}
      <WarningPopup />
      <WhatsAppButton onClick={open} />
    </div>
  );
};

export default Layout;
